import { EventType } from '../../common/types/event';
import { useEffect, MouseEvent, ChangeEvent, useState, Dispatch } from 'react';
import { ActionType } from '../../common/enum/action';
import { EventProps } from '../../interface/IEvent';
import { Defines } from '../../common/types/defines';

interface FetchActionProps {
  url: string;
  option?: { [key: string]: any };
  callback: Function;
}
interface ActivateActionProps {
  index?: number;
}
interface CollapseActionProps {}
interface NextActionProps {}

interface ActionsProps {
  [ActionType.NEXT]?: NextActionProps;
  [ActionType.ACTIVATE]?: ActivateActionProps;
  [ActionType.COLLAPSE]?: CollapseActionProps;
  [ActionType.FETCH]?: FetchActionProps;
  callback?: Function;
}

type ActionExecutorProps = {
  [type in EventType]: ActionsProps;
};

type ActionExecEvent = MouseEvent<HTMLElement> | ChangeEvent<HTMLElement>;

export interface CallbackDataProps {
  state: EventType;
  step: number;
  ts: number;
  value: { [key: string]: any };
}

const useActionExecutor = (
  props: EventProps,
  defines: Defines,
  setValue?: Dispatch<any>
) => {
  const [callbackData, setCallbackData] = useState<any>();
  const [executing, setExecuting] = useState<{[key: string]: boolean}>({});
  
  if (!props) return {};
  const eventTypes = Object.keys(props) as EventType[];
  const has = (t: EventType) => eventTypes.indexOf(t) >= 0;

  const exec = async (type: EventType) => {
    if (executing[type.toString()]) return [];
    setExecuting({ ...executing, [type.toString()]: true });
    const data = ((props[type] || {}) as any).data;
    const results = [];
    for (let cb of props[type].callbacks) {
      const callbackResult = await cb(data, defines, setValue);
      results.push(callbackResult);
      if (
        callbackResult === false ||
        (
          typeof callbackResult === "object" &&
          callbackResult.result === false
        )
      ) break;
    }
    setExecuting({ ...executing, [type.toString()]: false });
    return results;
    // const result = props[type].callbacks.every(f => false !== f(data, defines, setValue));
  }

  useEffect(() => {
    if (has(EventType.load)) {
      exec(EventType.load).then(executedData => {
        if (executedData !== undefined)
          setCallbackData(executedData);
      });
    }
  }, []);
  
  const click = has(EventType.click) ?
    (e?: MouseEvent<HTMLElement>) => 
      exec(EventType.click) : null;
  
  const change = has(EventType.change) ?
    (e?: ChangeEvent<HTMLElement>) => 
      exec(EventType.change) : null;
  
  return { click, change, data: callbackData, executing };
}

export default useActionExecutor;